module.exports = __webpack_public_path__ + "static/media/battery-level-20-charging.abc558bb.svg";